import { render, staticRenderFns } from "./mheader.vue?vue&type=template&id=01cba5c4&scoped=true"
import script from "./mheader.vue?vue&type=script&lang=js"
export * from "./mheader.vue?vue&type=script&lang=js"
import style0 from "./mheader.vue?vue&type=style&index=0&id=01cba5c4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cba5c4",
  null
  
)

export default component.exports